// extracted by mini-css-extract-plugin
module.exports = {"minimumEnvText":"style_minimumEnvText__3tXXb","minCompleteLabel":"style_minCompleteLabel__1OGQs"};